import type { ComponentType } from "react"
import { FileQuestionMark, type LucideProps } from "lucide-react"
import {
  DynamicIcon,
  dynamicIconImports,
  type IconName,
} from "lucide-react/dynamic"
import { cn } from "@components/ui/lib/utils"

type TLucideIconProps = {
  name: string | null | undefined
  className?: string
  fallback?: ComponentType<LucideProps>
}

const isIconName = (name: string | null | undefined): name is IconName =>
  !!name && name in dynamicIconImports

// Renders a Lucide icon from its kebab-case name, as sent by Garcon (e.g. "shopping-cart").
export const LucideIcon = ({
  name,
  className,
  fallback: Fallback = FileQuestionMark,
}: TLucideIconProps) => {
  if (!isIconName(name)) return <Fallback className={className} />

  return (
    <DynamicIcon
      name={name}
      // Static Lucide icons get this class, DynamicIcon doesn't.
      className={cn(`lucide-${name}`, className)}
      // Keeps the icon's space while it lazy loads, so the layout doesn't jump.
      fallback={() => (
        <span aria-hidden className={cn("tw:inline-block", className)} />
      )}
    />
  )
}
